import { ReactNode } from "react";

interface SmsConsentCheckboxProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Optional override for the label text (e.g. the dedicated opt-in page). */
  label?: ReactNode;
}

/**
 * Twilio A2P-compliant SMS opt-in checkbox.
 * Must render unchecked by default and name California Energy Group.
 */
const SmsConsentCheckbox = ({ id, checked, onChange, label }: SmsConsentCheckboxProps) => (
  <label htmlFor={id} className="flex items-start gap-2.5 text-left cursor-pointer select-none">
    <input
      id={id}
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="mt-0.5 h-5 w-5 shrink-0 accent-[hsl(var(--primary))] cursor-pointer"
    />
    <span className="text-xs leading-snug text-muted-foreground">
      {label ?? (
        <>
          I agree to receive text messages (including by automated means) from{" "}
          <span className="font-medium text-foreground">California Energy Group</span>{" "}
          at the number provided. Consent is not a condition of purchase. Msg &amp; data
          rates may apply. Reply STOP to opt out. See our{" "}
          <a href="/privacy-policy" className="text-secondary hover:underline">Privacy Policy</a>{" "}
          and{" "}
          <a href="/terms" className="text-secondary hover:underline">Terms</a>.
        </>
      )}
    </span>
  </label>
);

export default SmsConsentCheckbox;
